import { useEffect } from 'react';
import Intercom, { update, shutdown } from '@intercom/messenger-js-sdk';

import { useIsAnyFilterPanelOpen } from 'src/hooks/use-filter-panel-visibility';

import { useAuthContext } from 'src/auth/hooks';
import { INTERCOM_APP_ID } from 'src/config/env';
import { useGetProfileQuery } from 'src/graphql/generated';

// ----------------------------------------------------------------------

export default function IntercomWidget() {
  const { authenticated } = useAuthContext();

  const { data } = useGetProfileQuery({ skip: !authenticated });

  const me = data?.me;

  const isFilterPanelOpen = useIsAnyFilterPanelOpen();

  useEffect(() => {
    if (!authenticated || !me) return undefined;

    Intercom({
      app_id: INTERCOM_APP_ID,
      user_id: String(me.pk),
      name: `${me.firstName} ${me.lastName}`.trim(),
      email: me.email ?? undefined,
    });

    return () => shutdown();
  }, [authenticated, me]);

  // Esconde a bolha do Intercom enquanto algum painel de filtro estiver
  // aberto, pra não ficar sobreposta (o widget se injeta fora da árvore
  // React com z-index acima de qualquer Drawer do MUI).
  useEffect(() => {
    if (!authenticated || !me) return;

    update({ hide_default_launcher: isFilterPanelOpen });
  }, [authenticated, me, isFilterPanelOpen]);

  return null;
}
